import { Button, ButtonSize, ButtonVariant, IconVariants, Spinner, SpinnerSize } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";

import Trans from "../Trans/Trans";

interface IGenerateImageButtonProps {
  isGenerationInProgress: boolean;
  onCancelGeneration: () => void;
  onClick: () => void;
  isVisuallyDisabled: boolean;
  disabled: boolean;
}

const GenerateImageButton = ({ isGenerationInProgress, onCancelGeneration, onClick, isVisuallyDisabled, disabled }: IGenerateImageButtonProps) => {
  const { t } = useTranslation();
  const isDisabledWhileIdle = !isGenerationInProgress && isVisuallyDisabled;
  return (
    <Button
      variant={isGenerationInProgress ? ButtonVariant.OUTLINED : ButtonVariant.INVERSE}
      size={ButtonSize.MEDIUM}
      onClick={isGenerationInProgress ? onCancelGeneration : onClick}
      disabled={disabled}
      aria-disabled={isDisabledWhileIdle}
      className={`transition-all ${isDisabledWhileIdle ? "opacity-50 cursor-not-allowed" : "enabled:hover:opacity-80"}`}
      iconStart={isGenerationInProgress ? undefined : IconVariants.SPARKLES}
      aria-label={isGenerationInProgress ? t("common:modal.generateAvatar.cta.stopGeneration") : t("common:modal.generateAvatar.cta.generateImage")}
      data-testid="GenerateImageButton"
    >
      {!!isGenerationInProgress && <Spinner size={SpinnerSize.SMALL} className="mr-md" />}
      {isGenerationInProgress ? (
        <Trans i18nKey="common:modal.generateAvatar.cta.stopGeneration" />
      ) : (
        <Trans i18nKey="common:modal.generateAvatar.cta.generateImage" />
      )}
    </Button>
  );
};

export default GenerateImageButton;
